import { z } from 'my-zod'

export const rentalEquipmentMetadata = z.object({
  maxQuantityPerRider: z.number(),
  productIds: z.string().array()
})

export const merchandiseMetadata = z.object({
  category: z.string().optional()
})
export type rentalEquipmentMetadata = z.infer<typeof rentalEquipmentMetadata>
